document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const open = event.target.closest('[data-se-guide-open]');
  if (open) {
    const dialog = document.getElementById(open.dataset.seGuideOpen);
    if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
  }
  const close = event.target.closest('[data-se-guide-close]');
  if (close) close.closest('dialog')?.close();
  if (event.target instanceof HTMLDialogElement && event.target.classList.contains('se-guide-dialog')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});
document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-se-upsell-select]')) return;
  const form = event.target.closest('form');
  if (!form) return;
  form.querySelector('input[name="id"]').value = event.target.value;
  const quantity = form.querySelector('[data-se-upsell-quantity]');
  const minimum = event.target.selectedOptions[0]?.dataset.min || '1';
  if (quantity) quantity.value = minimum;
  const component = form.closest('product-form-component');
  if (component) component.dataset.quantityDefault = minimum;
});
